import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject, Injectable, Injector} from '@angular/core';
import {catchError, Observable, throwError} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../services/toast.service';

// Statuses déjà gérés par AuthInterceptor (401), ForbiddenInterceptor (403) et BusinessRuleInterceptor (422, 429)
const HANDLED_STATUSES = [401, 403, 422, 429];

@Injectable()
export class GenericErrorInterceptor implements HttpInterceptor {
  private readonly injector = inject(Injector);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Status 0 : réseau coupé, serveur injoignable ou requête bloquée. Sans lui, l'appel échoue
        // sans qu'aucun toast ne l'annonce.
        if ([0, 500].includes(error.status)) {
          const translateService = this.injector.get(TranslateService);
          const toastService = this.injector.get(ToastService);
          toastService.showMessage({
            severity: 'error',
            summary: translateService.instant('generic-error.title'),
            detail: translateService.instant('generic-error.detail'),
          });
        }
        return throwError(() => error);
      })
    );
  }
}
